
// Here we are importing the whole app
// read more about modules here:
// http://wesbos.com/javascript-modules/
import $ from 'jquery';
import './app';
import 'retinajs';
$(document).ready(function () {
  $('.tabs a').click(function (e) {
    e.preventDefault();
    $(this).parents('.tab-wrapper').find('a.active').removeClass('active');
    $(this).parents('.tab-wrapper').find(this).addClass('active');
    $(this).parents('.tab-wrapper').find('.tabs-content .active').removeClass('active');
    $($(this).attr('href')).addClass('active');
  });
  $('.next').click(function (e) {
    e.preventDefault();
    if ($(this).parents('.tab-wrapper').find('.tabs a.active').parent('li').next('li').length > 0) {
      $(this).parents('.tab-wrapper').find('.tabs a.active').parent('li').next('li').find('a').trigger('click');
    }
  });
  $('.pre').click(function (e) {
    e.preventDefault();
    if ($(this).parents('.tab-wrapper').find('.tabs a.active').parent('li').prev('li').length > 0) {
      $(this).parents('.tab-wrapper').find('.tabs a.active').parent('li').prev('li').find('a').trigger('click');
    }
  });
  // header menu
  $('.menu').click(function (e) {
    e.preventDefault();
    $('nav').slideToggle();
  })
  // form
  $('.request .btn.active').click(function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $('#popup').offset().top
    }, 2000);
    $('#popup').toggle();
    $('#popup .btn.close').click(function (e) {
      e.preventDefault();
      $('#popup').fadeOut();
    })
    $('#popup .btn.next').click(function (e) {
      e.preventDefault();
      $('#popup .wrappper').hide();
      $('#popup .wrappper-2').fadeIn();
    })
    $('#popup .btn.previous').click(function (e) {
      e.preventDefault();
      $('#popup .wrappper-2').hide();
      $('#popup .wrappper').fadeIn();
    })
  })
})
